<script>

import {axios} from '../../mixins';
import Modal from '../Modal.vue';
import {Alerts} from '../../mixins/Alerts.js';

export default {

  name: 'ContractsSubmit',

  components: {Modal},

  mixins: [axios],

  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    userId: {
      required: true,
      type: Number,
    },
    farmId: {
      required: true,
      type: Number,
    },
    orgName: {
      required: true,
      type: String,
    }
  },

  data() {
    return {
      response: '',
      alerts: new Alerts(),
      formattedErrors: [],
      status: null,
      permanentDisable: false,
      submitButtonClasses: 'button button-wide text-white bg-blue hover:bg-blue-dark focus:bg-blue-darker font-bold',
      submitButtonClassesDisabled: 'button button-wide text-white bg-blue font-bold opacity-50 cursor-not-allowed',
      bodyText: '',
    };
  },

  computed: {},

  methods: {
    validate() {
      this.status = 'validating'
      this.alerts.initialize()
      this.get('/validate/contracts?user_id=' + this.userId + '&farm_id=' + this.farmId).then((response) => {
        if (Object.keys(response.data.errors).length > 0) {
          this.alerts.recordErrors(response.data.errors)
          this.formattedErrors = this.formatErrors()
          this.status = 'invalid'
        } else {
          this.response = 'Success!'
          this.status = 'valid'
          this.bodyText = response.data.bodyText
        }
      })
    },

    submitContract() {
      this.alerts.initialize()
      this.post('/contracts/store', {user_id: this.userId, farm_id: this.farmId}).then((response) => {
        this.status = 'submitted'
        this.$emit('submitted');
        this.permanentDisable = true
        // check modal is still open
        if (this.$refs.submitModal.showModal) {
          this.response = response.data.message
        }
      })
    },

    formatErrors: function () {
      let errors = this.alerts.getErrors()
      let formattedErrors = []
      for (const [type, errorsList] of Object.entries(errors)) {

        for (const [id, message] of Object.entries(errorsList)) {
          formattedErrors.push({
            type: type,
            id: id,
            message: message
          })
        }
      }

      return formattedErrors;
    },

    showResource(type, id) {
      this.$refs.submitModal.cancel()
      this.status = null

      this.$emit('show', type, id)
    },
  },
};

</script>

<template>

  <Modal :small="true" v-on:open="validate" ref="submitModal">
    <div class="flex flex-row p-4 text-black">
        <span v-show="status==='validating'" class="text-orange">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
        </span>
      <span v-show="status==='valid'" class="text-green">
            <i class="far fa-check-circle fa-3x"></i>
        </span>
      <span v-show="status==='invalid'" class="text-red">
            <i class="fal fa-times-circle fa-3x"></i>
        </span>
      <div class="flex flex-col pl-4">
        <p v-if="status==='validating'">
          Please wait while we validate your application. (Go get some coffee. This could take a few minutes).
        </p>
        <div v-else-if="status==='valid'">
          <p>
            {{ this.bodyText }}
          </p>
        </div>
        <div v-else-if="status==='invalid'">
          <div v-if="response" class="text-white mt-2">
            {{ response }}
          </div>

          <div v-if="!alerts.isEmpty()">
            <ul>
              <li class="text-black">
                Some of your farm data is invalid or missing. Click on the links below to correct the invalid data, then
                resubmit.
              </li>
              <li v-for="error in formattedErrors" class="text-red text-xs">

                <a :href="error.id" v-if="error.type ==='urls'">{{ error.message }}</a>
                <button type="button" @click="showResource(error.type,error.id)" class="cursor-pointer" v-else>
                  {{ error.message }}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="status==='submitted'">
          Thank you for submitting your application to the {{ this.orgName }}. You will be contacted in a few
          days with your per acre payment offer. At that point you can decide if you would like to move on
          to contracting.
        </div>
      </div>
    </div>

    <template #toggle="{open}">
      <button
          v-on:click="open"
          :class="!(disabled || permanentDisable) ? submitButtonClasses : submitButtonClassesDisabled"
          :disabled="(disabled || permanentDisable)"
          type="button" name="Validate Contract">
        <span v-if="(disabled || permanentDisable)">Submitted <i class="fas fa-check"></i></span>
        <span v-else>Submit My Application</span>
      </button>
    </template>

    <template #footer="{close,cancel}">
      <div class="flex justify-between">
        <span class="mt-3 flex w-full sm:mt-0 sm:w-auto">
          <button type="button"
                  class="button button-wide text-white bg-grey-light hover:bg-grey focus:bg-grey-darker font-bold"
                  v-on:click="cancel">
            {{ !(status === 'submitted') ? 'Cancel' : 'Close' }}
          </button>
        </span>

        <span v-if="!(status==='submitted')" class="flex sm:ml-3">
          <button
              :class="(status==='valid') ? submitButtonClasses : submitButtonClassesDisabled"
              type="button" name="Submit Contract" @click="submitContract"
              :disabled="!(status==='valid')">Approve & Submit
          </button>
        </span>
      </div>
    </template>
  </Modal>

</template>
